<template>
  <div>
    <el-dialog
        :visible.sync="isOpenUpdateShiftOneObjectDialog"
        width="70%"
        :before-close="closeDialog"
        :close-on-click-modal="false"
        top="2vh"
        @open="handleOpen"
        title="Thiết lập chi tiết"
    >
        <div class="table-content row-data">
          <el-table
              :empty-text="textTable"
              :element-loading-text="$tableLoading"
              element-loading-spinner="el-icon-loading"
              element-loading-background="rgba(255,255,255, 0)"
              highlight-current-row
              :data="localShiftList"
              :header-cell-style="tableHeaderColor"
              @selection-change="handleSelectionChange"
              border
              :max-height="500"
          >
            <el-table-column
                type="index"
                label="STT"
                width="50"
                align="center"
            ></el-table-column>
            <el-table-column
                prop="shiftName"
                label="Tên ca"
                align="left"
            ></el-table-column>
            <!-- danh sách thứ -->
            <el-table-column
                align="center"
                v-for="(item) in headerTab1List"
                :key="item.id"
            >
              <template slot="header" slot-scope="scope">
                <el-popover
                    placement="top"
                    align="center"
                    width="200"
                    trigger="hover"
                    :content="item.name"
                >
                 <span
                     slot="reference"
                     class="truncate-text"
                     :title="item.name"
                 >
                    {{ item.name }}
                  </span>

                </el-popover>
                <br/>
                <br/>
                <el-checkbox
                    @change="
                    checkHeaderPackageKidsMethod(
                      scope.$index,
                      item.id,
                      item.check
                    )
                  "
                    v-model="item.check"
                ></el-checkbox>
              </template>

              <template slot-scope="scope">
                <el-checkbox
                    :disabled="!scope.row.assigned"
                    v-model="scope.row.dayList.find(d => d.id === item.id).active"
                    @change="() => {
                      updateAssignedForRow(scope.row);
                      updateHeaderCheck(item.id);
                    }"
                ></el-checkbox>

              </template>
            </el-table-column>
            <el-table-column
                width="200"
                label="Áp dụng bữa ăn"
                align="left"
            >
              <template slot-scope="scope">
                <el-select
                    v-model="scope.row.meals"
                    placeholder="Chọn bữa ăn"
                    multiple
                    collapse-tags
                    :disabled="!scope.row.applyAttendanceEat || !scope.row.assigned"
                    style="width: 100%"
                >
                  <el-option
                      v-for="item in valueAttendanceEatList"
                      :key="item.value"
                      :value="item.value"
                      :label="item.label"
                  />
                </el-select>
              </template>
            </el-table-column>


          </el-table>
        </div>
      <div class="tab-infor-button">
        <el-button
            type="success"
            size="medium"
            :loading="loadingButton"
            mini
            @click="handleSave()"
        >
          <i class="el-icon-circle-check"/>
          <span>Lưu</span>
        </el-button>
        <el-button type="danger" size="medium" @click="closeDialog()">
          <span>Đóng</span>
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>

import shiftMaster from "@/services/ShiftMaster";
import NotifyMessage from "@/commonFuncion/NotifyMessage";

export default {
  name: "UpdateShiftOneObjectDialog",
  props: {
    isOpenUpdateShiftOneObjectDialog: {
      type: Boolean,
      default: () => false,
    },
    shiftList: {
      type: Array,
      default: () => [],
    },
    teamId: {
      type: [String, Number],
      default: null
    },
    teamType: {
      type: [String, Number],
      default: null
    },
    targetType: {
      type: [String, Number],
      default: null
    },
  },
  data() {
    return {
      textTable: "",
      idAppSend: "",
      loadingButton: false,
      shiftListSearch: [],
      multipleSelection: [],
      localShiftList: [],
      meals: [],
      valueAttendanceEatList: [
        {key: "EAT_BREAKFAST", value: "eatBreakfast", label: "Bữa sáng"},
        {key: "EAT_BREAKFAST_SECOND", value: "eatBreakfastSecond", label: "Bữa phụ sáng"},
        {key: "EAT_LUNCH", value: "eatLunch", label: "Bữa trưa"},
        {key: "EAT_AFTERNOON", value: "eatAfternoon", label: "Bữa chiều"},
        {key: "EAT_AFTERNOON_SECOND", value: "eatAfternoonSecond", label: "Bữa phụ chiều"},
        {key: "EAT_DINNER", value: "eatDinner", label: "Bữa tối"},
      ],
      headerTab1List: [
        {id: 1, name: "Thứ hai"},
        {id: 2, name: "Thứ ba"},
        {id: 3, name: "Thứ tư"},
        {id: 4, name: "Thứ năm"},
        {id: 5, name: "Thứ sáu"},
        {id: 6, name: "Thứ bảy"},
        {id: 7, name: "Chủ nhật"},
      ]
    };
  },
  methods: {
    handleOpen() {
      this.localShiftList = this.shiftList.map(s => {
        const shift = JSON.parse(JSON.stringify(s));

        const activeDays = shift.applyDays
            ? shift.applyDays.split(",").map(Number)
            : [];

        shift.dayList = this.headerTab1List.map(day => ({
          id: day.id,
          active: activeDays.includes(day.id)
        }));
        // set assigned ngay từ đầu
        shift.assigned = activeDays.length > 0;

        if (shift.meals && shift.meals.trim() !== "") {
          shift.meals = shift.meals.split(",");
        } else {
          shift.meals = [];
        }
        return shift;
      });

      // reset tất cả header check
      this.headerTab1List = this.headerTab1List.map(d => ({ ...d, check: false }));

      // tính lại trạng thái header check theo dữ liệu
      this.headerTab1List.forEach(day => {
        this.updateHeaderCheck(day.id);
      });
    },

    tableHeaderColor() {
      return "background-color: #78a5e7;color: #fff;font-weight: bold;border:1px solid #fff";
    },
    closeDialog() {
      this.$emit("dialog-close");
    },
    checkHeaderPackageKidsMethod(index, dayId, value) {
      this.localShiftList.forEach(row => {
        // CHỈ xử lý những row đã assigned
        if (!row.assigned) return;

        const day = row.dayList.find(d => d.id === dayId);
        if (day) {
          day.active = value;
        }

        // this.updateAssignedForRow(row);
      });

      this.updateHeaderCheck(dayId);
    },
    updateHeaderCheck(dayId) {
      const dayInfo = this.headerTab1List.find(h => h.id === dayId);
      if (!dayInfo) return;

      const assignedRows = this.localShiftList.filter(r => r.assigned);

      if (assignedRows.length === 0) {
        dayInfo.check = false;
        return;
      }

      dayInfo.check = assignedRows.every(row =>
          row.dayList.find(d => d.id === dayId)?.active === true
      );
    },

    handleSave() {
      const payload = this.convertBeforeSave();
      shiftMaster.createShiftAssignments(payload)
          .then(() => {
            NotifyMessage.leftCornerNotificationSuccess("Lưu thay đổi thành công");
            this.closeDialog();
          })
          .catch(() => {
            NotifyMessage.leftCornerNotificationError("Lưu thay đổi thất bại");
          });
    },

    convertBeforeSave() {
      const data = [];

      this.localShiftList.forEach(shift => {
        // Lấy danh sách ngày được chọn
        const selectedDays = shift.dayList
            .filter(d => d.active)
            .map(d => d.id);

        data.push({
          shiftId: shift.shiftId,
          targetId: shift.targetId,
          teamId: this.$props.teamId,
          teamType: this.$props.teamType,
          targetType: this.$props.targetType,
          assignment: shift.assigned,
          overrideApplyDays: selectedDays.length > 0 ? selectedDays.join(",") : null,
          meals: shift.meals && shift.meals.length > 0
              ? shift.meals.join(",")
              : null
        });
      });

      return data;
    },

    updateAssignedForRow(row) {
      row.assigned = row.dayList.some(d => d.active === true);
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
  },
};
</script>
<style>
.hideUpload > div {
  visibility: hidden;
}
</style>
<style lang="scss" scoped>
// /deep/.el-input__inner,
// /deep/.el-textarea__inner {
//   border: none;
//   border-radius: 0;
//   resize: none;
//   padding-left: 0;
//   padding-right: 0;
//   border-bottom: 1px solid #d9d9d9;
// }

/deep/ .el-dialog__title {
  font-size: 25px;
  color: #606266;
}

/deep/ .el-form-item__label {
  font-family: Arial, Helvetica, sans-serif;
}

/deep/ .upload-demo {
  text-align: center;

  .el-upload {
    width: 100%;
  }
}

/deep/ .el-table th > .cell {
  text-align: center !important;
}

/deep/ .el-avatar {
  display: inline;

  img {
    border-radius: 5px;
    width: 100%;
  }
}

/deep/ .el-input.is-disabled .el-input__inner {
  text-align: center;
  color: #d13b93;
  font-weight: bold;
}

.el-select {
  display: block;
}

.tab-infor-button {
  text-align: right;
  margin-top: 20px;
}

.bg-purple {
  background: #d3dce6;
}

.grid-content {
  border-radius: 4px;
  min-height: 36px;
}

.group-radio-status {
  margin: 0 50px;

  .kids-status {
    margin-bottom: 10px;
  }
}

/deep/ .el-tabs__nav {
  background: #a0a19ce0;
}

/deep/ .el-tabs__item {
  color: white;
}

/deep/ .el-tabs__item.is-active {
  color: white;
  background: #67c23a;
}

/deep/ .el-form-item.is-required:not(.is-no-asterisk) > .el-form-item__label:after {
  content: "*";
  color: #f56c6c;
  margin-left: 3px;
}

/deep/ .el-form-item.is-required:not(.is-no-asterisk) > .el-form-item__label:before {
  content: "";
  color: #f56c6c;
  margin-left: -4px;
}

.table-icon-1 {
  width: 30%;
  margin-left: 15%;
  display: inline-block;
}

.table-icon-2 {
  width: 30%;
  margin-right: 15%;
  float: right;
}

.button-left-class {
  margin-right: 5px;
  width: 150px;
}

.search-table {
  margin-bottom: 20px;
  position: relative;
  z-index: 1;
  display: flex;
  width: 100%;
}

.search-table > * {
  margin-right: 5px; /* Khoảng cách 5px giữa các khối con */
}
</style>
